<template>
    <v-flex xs12 class="asset-summary">
        <v-card class="asset-data-table">
            <v-layout row wrap class="table-title-bar">
                <v-flex xs12 md7 sm5>
                    <v-flex tag="h2">{{showtitle()}}</v-flex>
                </v-flex>
                <v-flex xs12 md5 sm7 text-sm-right v-if="isCurrentUser">
                    <span v-if="!editMode" 
                        @click="manageAssets()"
                        data-qe-id="manageAssetsBtn"
                        class="manage-asset-details">{{assetSummaryConstants.MANAGE_ASSETS}}</span>
                    <span v-if="editMode"
                        @click="manageAssets()"
                        data-qe-id="viewAssetsBtn"
                        class="manage-asset-details">{{assetSummaryConstants.VIEW_ASSETS}}</span>
                    <!-- TODO: Need remove false in v-if after the implementation of download assets API -->
                    <span v-if="false && assetSummary.length"
                        @click="downloadAssets()"
                        data-qe-id="downloadAssetsBtn"
                        class="download-asset-info">{{assetSummaryConstants.DOWNLOAD_ASSETS}}</span>
                </v-flex>
            </v-layout>
            <v-flex class="asset-data-table-scroll" v-show="showdatatable">
                <v-data-table
                    :headers="columns"
                    :items="assetSummary"
                    v-model="selected"
                    item-key="id"
                    :select-all="editMode" 
                    :expand="editMode"
                    no-data-text=''
                    :loading="true"
                    :hide-actions="!isAssetsExist"
                    :rows-per-page-items="[5,10,25]"
                    :pagination.sync="pagination">
                    <template slot="headers" slot-scope="props">
                        <tr>
                            <th class="checkbox-header" id="selectAllHeader" v-if="editMode && isAssetsExist">
                                <v-flex tag="h6">{{assetSummaryConstants.SELECT_ALL}}</v-flex>
                                <v-checkbox
                                    :input-value="props.all"
                                    :indeterminate="props.indeterminate"
                                    hide-details
                                    color="white"
                                    data-qe-id="selectAllchkbox"
                                    @click.stop="toggleAll">
                                </v-checkbox>
                            </th>
                            <th class="checkbox-header" id="emptyHeader" v-if="editMode"></th>
                            <th
                                v-for="header in props.headers"
                                :class="[header.sortable ?'column sortable white--text' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                                @click="changeSort(header)"
                                :id="`column_${header.value}`"
                                :data-qe-id="`column_${header.value}`"
                                :key="header.text">
                                {{ header.text }}
                                <v-icon v-if="header.sortable" small color="white">arrow_upward</v-icon>
                            </th>
                        </tr>
                    </template>
                    <template slot="progress">
                        <status-overlay :action="loadGetAssetSummaryAction" contentHeight="100px">
                        </status-overlay>
                    </template>
                    <template slot="items" slot-scope="props">
                        <td v-if="editMode && isAssetsExist" class="checkbox-header">
                            <v-checkbox
                                v-model="props.selected"
                                color="ypo_cta"
                                :data-qe-id="`checkbox_${props.item.id}`"
                                @click.stop="onCheckboxSelect(props)"
                                hide-details>
                            </v-checkbox>
                        </td>
                        <td @click="checkExpanded(props)" v-if="editMode && isAssetsExist" class="checkbox-header"> 
                            <i v-if="!(props.expanded && props.item.expanded)" 
                                :data-qe-id="`expandRowBtn_${props.item.id}`"
                                class="fa fa-plus-square fa-lg" 
                                aria-hidden="true"></i>
                            <i v-if="props.expanded && props.item.expanded" 
                                :data-qe-id="`collapseRowBtn_${props.item.id}`"
                                class="fa fa-minus-square fa-lg" 
                                aria-hidden="true"></i>
                        </td>
                        <td><span :title="props.item.name">{{ props.item.name }}</span></td>
                        <td><span :title="props.item.address1">{{ props.item.address1 }}</span></td>
                        <td><span :title="props.item.city">{{ props.item.city }}</span></td>
                        <td><span :title="props.item.country">{{ props.item.country }}</span></td>
                        <td><span :title="props.item.region">{{ props.item.region }}</span></td>
                        <td><span :title="props.item.assetStatus">{{ props.item.assetStatus }}</span> </td>
                    </template>
                    <template slot="expand" slot-scope="props">
                        <asset-summary-edit 
                            :formData="props" 
                            :memberId="memberId" 
                            v-if="props.item.expanded"
                            @alert="showAlert"
                            @close="closeOrCollapseForm(false, props)">
                        </asset-summary-edit>      
                    </template>
                    <template slot="no-data" v-if="!showNewAssetForm"> 
                        <v-flex mt-5 xs12 text-xs-center class="no-data" v-if="isCurrentUser">{{assetSummaryConstants.NO_EXISTING_ASSETS_TEXT1}}</v-flex>
                        <v-flex mt-5 mb-5 xs12 text-xs-center class="no-data" v-if="!isCurrentUser">{{assetSummaryConstants.NO_EXISTING_ASSETS_TEXT1}}</v-flex>
                        <v-flex xs12 text-xs-center class="no-data" v-if="isCurrentUser">{{assetSummaryConstants.NO_EXISTING_ASSETS_TEXT2}}</v-flex> 
                        <v-flex mb-5 xs12 text-xs-center class="no-data" v-if="isCurrentUser">{{assetSummaryConstants.NO_EXISTING_ASSETS_TEXT3}}</v-flex>
                    </template>
                    <template slot="footer" v-if="showNewAssetForm" ref="newAssetFormSlot">
                        <asset-summary-edit 
                            :formData="{}"
                            :memberId="memberId"
                            @alert="showAlert"
                            @close="closeOrCollapseForm(true)">
                        </asset-summary-edit>
                    </template>
                </v-data-table>
                <v-layout row wrap class="bottom-buttons" pa-3 v-if="editMode && isCurrentUser">
                    <v-flex md1 sm1 xs3>
                        <v-flex tag="h4" 
                            :class="selected.length ?'delete':'disabled-text'"
                            v-if="isAssetsExist"
                            data-qe-id="deleteAssetsBtn"
                            @click="showDeleteAssetsDialog">{{appCommonConstants.DELETE}}</v-flex>
                    </v-flex>
                    <v-flex md2 xs5>
                        <v-flex tag="h4" 
                            :class="selected.length ?'duplicate-assets':'disabled-text'"
                            v-if="isAssetsExist"
                            data-qe-id="duplicateAssetsBtn"
                            @click="duplicateAssets">{{assetSummaryConstants.DUPLICATE_ASSETS}}</v-flex>
                    </v-flex>
                    <v-flex md9 xs4 text-xs-right></v-flex>
                    <v-flex xs3>
                        <v-btn data-qe-id="addNewAssetsBtn" class="dashed-square-btn" @click="displayNewAssetForm()">
                            <i class="fas fa-plus-circle mr-2"></i> {{assetSummaryConstants.NEW_ASSETS}}
                        </v-btn>
                    </v-flex>   
                    <v-flex xs9 mt-4 text-xs-right>
                        <v-flex tag="h4" 
                            data-qe-id="bulkAddLink"
                            v-if="!(isAndroidAppBrowser || isIosAppBrowser)"
                            class="bulk-upload"
                            @click="showBulkAddDialog">{{assetSummaryConstants.BULK_UPLOAD}}</v-flex>
                    </v-flex>
                </v-layout>
            </v-flex>
            <BulkUpload v-if="!showdatatable" />
        </v-card>
        <confirmation-dialog 
            v-model="deleteAssetsDialog"
            typeOfDialog="confirm"
            :actionName="deletAssetsAction"
            :yesFunction="deleteAssetDetails"
            :title="assetSummaryConstants.DELETE_ASSETS_TITLE"
            :message="assetSummaryConstants.DELETE_ASSET_CONFIRMATION"
            :yesText="appCommonConstants.DELETE"
            :noText="appCommonConstants.CANCEL">
        </confirmation-dialog>
        <confirmation-dialog
            v-model="submissionCompleteDialog"
            typeOfDialog="alert"
            :yesFunction="onSaveSuccess"
            :closeFunction="onSaveSuccess"
            :title="assetSummaryConstants.SUBMISSION_COMPLETE_TITLE"
            :message="assetSummaryConstants.SUBMISSION_COMPLETE_TEXT"
            :yesText="assetSummaryConstants.OK">
        </confirmation-dialog>
        <confirmation-dialog
            v-model="saveSuccessDialog"
            typeOfDialog="alert"
            :yesFunction="onSaveSuccess"
            :closeFunction="onSaveSuccess"
            :title="assetSummaryConstants.ASSET_SAVE_TITLE"
            :message="assetSummaryConstants.ASSET_SAVE"
            :yesText="assetSummaryConstants.OK">
        </confirmation-dialog>
        <confirmation-dialog
            class="asset-edit__dialog"
            v-model="showAssetMappingExistDialog"
            typeOfDialog="alert"
            :title="assetSummaryConstants.ASSET_OWNER_EXIST"
            :message="assetSummaryConstants.ASSET_OWNER_ALREADY_EXIST"
            :yesText="assetSummaryConstants.OK">
        </confirmation-dialog>
        <confirmation-dialog
            class="bulk-add-info"
            v-model="bulkAddInitalDialog"
            typeOfDialog="alert"
            :message="assetSummaryConstants.BULK_ADD_MESSAGE_PART"
            :yesText="assetSummaryConstants.GET_STARTED"
            :yesFunction="openBulkAdd">
        </confirmation-dialog>
    </v-flex>
</template>
<script>
    import { assetSummaryConstants } from './memberProfile.constants';
    import { appCommonConstants } from "../appCommon.constants.js";
    import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeMutation } from '../../store/storeMutations.constant';
    import StatusBar from "../StatusBar/StatusBar";
    import StatusOverlay from '@/components/StatusOverlay/StatusOverlay';
    import AssetSummaryEdit from './EditDialogues/AssetSummaryEdit';
    import ConfirmationDialog from './EditDialogues/ConfirmationDialog';
    import BulkUpload from './BulkUpload';
    import Vue from 'vue';

    export default {
        name: 'AssetsSummary',
        data: () => ({
            assetSummaryConstants,
            appCommonConstants,
            columns: assetSummaryConstants.COLUMN_HEADERS,
            deleteAssetsDialog: false,
            editMode: false,
            pagination: {
                sortBy: 'name',
            },
            selected: [],
            showNewAssetForm: false,
            submissionCompleteDialog: false,
            saveSuccessDialog: false,
            showAssetMappingExistDialog: false,
            bulkAddInitalDialog: false,
            showdatatable: true,
        }),
        components: {
            AssetSummaryEdit,
            ConfirmationDialog,
            StatusBar,
            StatusOverlay,
            BulkUpload,
        },
        props: {
            memberId: {
                type: String,
                required: true,
            },
        },
        created() {
            this.getAssetSummary(this.memberId).then((res) => {
                if (res && res.data) {
                    this.editMode = res.data.length <= 0;
                }
            });
        },
        methods: {
            ...mapActions({
                getAssetSummary: `memberProfile/${storeAction.getAssetSummary}`,
                addDuplicateAssets: `memberProfile/${storeAction.addDuplicateAssets}`,
                deleteAssets: `memberProfile/${storeAction.deleteAssets}`,
            }),
            ...mapMutations({
                setOwnerProfiles: `memberProfile/${storeMutation.setSearchProfile}`,
                setStreetAddress: `memberProfile/${storeMutation.setStreetAddress}`,
            }),
            toggleAll() {
                if (this.selected.length) {
                    this.selected = [];
                } else {
                    this.selected = this.assetSummary.slice();
                }
            },
            checkExpanded(data) {
                data.expanded = !data.expanded;
                data.item.expanded = data.expanded;
                this.setOwnerProfiles([]);
                this.setStreetAddress('');
                this.showNewAssetForm = false;
            },
            manageAssets() {
                this.editMode = !this.editMode;
                this.selected = [];
                this.assetSummary.forEach((item) => {
                    item.expanded = false;
                });
                this.showNewAssetForm = false;
                this.setOwnerProfiles([]);
                this.showdatatable = true;
            },
            onCheckboxSelect(data) {
                data.selected = !data.selected;
            },
            duplicateAssets() {
                if (this.selected.length) {
                    const selectedAssets = Vue.util.extend([], this.selected);
                    this.selected = [];
                    this.addDuplicateAssets(selectedAssets).then(() => {
                        this.getAssetSummary(this.memberId).then(() => {
                            this.editMode = true;
                        });
                    });
                }
            },
            showDeleteAssetsDialog() {
                if (this.selected.length) {
                    this.deleteAssetsDialog = true;
                }
            },
            deleteAssetDetails() {
                if (this.selected.length) {
                    const assetIds = this.selected.map((x) => {
                        const assetObj = {};
                        assetObj.assetId = x.id;
                        assetObj.personId = this.memberId;
                        return assetObj;
                    });
                    this.deleteAssets(assetIds).then(() => {
                        this.selected = [];
                        this.deleteAssetsDialog = false;
                        this.getAssetSummary(this.memberId).then(() => {
                            this.editMode = true;
                        });
                    });
                }
            },
            changeSort(header) {
                if (header.sortable) {
                    const column = header.value;
                    if (this.pagination.sortBy === column) {
                        this.pagination.descending = !this.pagination.descending;
                    } else {
                        this.pagination.sortBy = column;
                        this.pagination.descending = false;
                    }
                }
            },
            closeOrCollapseForm(isNew, props) {
                if (isNew) {
                    this.showNewAssetForm = false;
                } else {
                    this.checkExpanded(props);
                }
            },
            displayNewAssetForm() {
                this.showNewAssetForm = true;
                this.setStreetAddress('');
                this.assetSummary.forEach((item) => {
                    item.expanded = false;
                });
            },
            onSaveSuccess() {
                this.getAssetSummary(this.memberId);
                this.showNewAssetForm = false;
                this.assetSummary.forEach((item) => {
                    item.expanded = false;
                });
                this.submissionCompleteDialog = false;
                this.saveSuccessDialog = false;
            },
            showAlert(value) {
                switch (value) {
                    case 'submissionCompleteDialog':
                        this.submissionCompleteDialog = true;
                        break;
                    case 'saveSuccessDialog':
                        this.saveSuccessDialog = true;
                        break;
                    case 'showAssetMappingExistDialog':
                        this.showAssetMappingExistDialog = true;
                        break;
                    default: 
                        break;
                }
            },
            showBulkAddDialog() {
                this.bulkAddInitalDialog = !this.bulkAddInitalDialog;
            },
            openBulkAdd() {
                this.bulkAddInitalDialog = false;
                this.showdatatable = false;
                this.editMode = false;
            },
            showtitle() {
                return this.showdatatable ? this.assetSummaryConstants.ASSET_SUMMARY_TITLE : this.assetSummaryConstants.BULK_ADD_MANAGE_BUSINESSES;
            },
        },
        computed: {
            ...mapState("actionState", ["actions"]),
            ...mapGetters({
                assetSummary: `memberProfile/${storeGetters.assetSummary}`,
                currentUserId: `memberProfile/${storeGetters.currentUserId}`,
                isAndroidAppBrowser: `${[storeGetters.isAndroidAppBrowser]}`,
                isIosAppBrowser: `${[storeGetters.isIosAppBrowser]}`,
            }),
            loadGetAssetSummaryAction() {
                return this.actions[storeAction.getAssetSummary];
            },
            deletAssetsAction() {
                return this.actions[storeAction.deleteAssets];
            },
            isAssetsExist() {
                return this.assetSummary.length > 0;
            },
            isCurrentUser() {
                return this.memberId === this.currentUserId;
            },
        },
    };
</script>
<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";
    .asset-summary {
        .asset-data-table {
            border: 1px solid rgba($ypo-gray, 0.4);
            border-radius: 4px;
            background-color: $white;
            box-shadow: 0 1px 3px 0 rgba($black, 0.18);
            .table-title-bar {
                align-content: center;
                h2 {
                    margin: 20px;
                }
            }
            .download-asset-info {
                color: $ypo-cta;
                font-size: 14px;
                margin: 20px 10px;
                display: inline-block;
                cursor: pointer;                
                font-weight: 600;
                &:hover {
                    color: $ypo-blue;
                }

            }
            .manage-asset-details {
                color: $ypo-cta;
                font-size: 14px;
                margin: 20px 10px;
                display: inline-block;
                cursor: pointer;               
                font-weight: 600;
                &:hover {
                    color: $ypo-blue;
                }
                @include breakpoint(xs) {
                    position: relative;
                    right: 0;
                }
            }
            .asset-data-table-scroll {
                tr {
                    background: $ypo-dark-gray;
                    th {
                        color: $white;
                        font-weight: 600;
                        text-align: left;
                    }
                    td {
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        overflow: hidden;
                        color: $ypo-gray-text;
                    }                  
                }
                .checkbox-header {
                    width: 70px;
                    i {
                        color: $ypo-cta;
                        cursor: pointer;
                        font-size:20px;
                        vertical-align: middle;
                    }
                }
                .bottom-buttons {
                    .delete {
                        color: $ypo-cta;
                        font-size: 14px;
                        cursor: pointer;                       
                        font-weight: 600;
                        &:hover {
                            color: $ypo-blue;
                        }
                    }
                    .duplicate-assets {
                        color: $ypo-cta;
                        font-size: 14px;                       
                        cursor: pointer;                      
                        font-weight: 600;
                        &:hover {
                            color: $ypo-blue;
                        }
                    }
                    .disabled-text {
                        color: $ypo-gray;
                        font-size: 14px;                                          
                        font-weight: 600;
                        background-color: transparent;
                    }
                    
                    .bulk-upload {
                        color: $ypo-cta;
                        font-size: 14px;
                        cursor: pointer;
                        right: 20px;
                        bottom: 15px;
                        font-weight: 600;
                        &:hover {
                            color: $ypo-blue;
                        }
                    }
                    .dashed-square-btn {
                        display: inline-block;
                        padding: 0.5em 1em;
                        text-decoration: none;
                        color: $ypo-cta;
                        border: dashed 1px $ypo-cta;
                        border-radius: 3px;
                        transition: .4s;
                        margin: 15px 0 0 0;
                        font-weight: bold;
                        &:hover {
                            border-style: dotted;
                            color: $ypo-cta-hover;
                        }
                    }
                }
            }
        }
        .overlay {
            top: 120px;
            bottom: 50px;
        }
        .bulk-info {
            p {
                color: $ypo-blue !important;
            }
        }
        @include breakpoint(xs) {
            .asset-data-table {
                margin-top: 20px;
            }
            .download-asset-info {
                margin: 15px 10px;
            }
            .table-title-bar {
                h2 {
                    margin: 10px 10px 0 !important;
                }
            }
        }
        @include breakpoint(sm) {
            .asset-data-table {
                margin-top: 20px;
            }
        }
    }
</style>
<style lang="scss">
@import "../../common/styles/_colors.scss";
@import "../../common/styles/_responsive.scss";
.asset-data-table-scroll {
    .v-table__overflow {
        overflow: inherit;
        &::-webkit-scrollbar {
            width: 4px;
            height: 4px;
            background-color: $white;
        }
        &::-webkit-scrollbar-thumb {
            background: $ypo-cta;
            border-radius: 4px;
            height: 4px;
        }
    }
    .v-datatable {
        tbody {
            display:block;
            max-height: 490px;
            overflow-y:scroll;
            &::-webkit-scrollbar {
                width: 4px;
                height: 8px;
                background-color: $white;
            }
            &::-webkit-scrollbar-thumb {
                background: $ypo-cta;
                border-radius: 4px;
            }
            .no-data {
                font-size: 20px;
                color: $ypo-gray;
            }
        }
        thead, tbody tr {
            display:table;
            width:100%;
            table-layout:fixed; 
        }
        th {
            &.checkbox-header {
                .v-input--selection-controls__input {
                    i {
                        color: $white;
                    }
                }
            }
        }    
    }
    &.asset-pending {
        .v-datatable {
            tbody {
                overflow: inherit;
                max-height: inherit;
                .asset-edit {
                    margin: 0 10px;
                }
            }
        }
    }
    @include breakpoint(sm) {
        table.v-datatable {
            width: 1000px;
            max-width: 1000px;
        } 
        .v-table__overflow {
            overflow: auto;
        }         
    }
}
.bulk-add-info {
    p{
        padding: 10px;
    }
}
</style>
